import Swal from 'sweetalert2';

async function errorAlert({ opcoes = {}, proximo = () => {} }) {
  const result = await Swal.fire({
    reverseButtons: true,
    title: 'Ocorreu um erro',
    icon: 'error',
    confirmButtonColor: '#d33',
    confirmButtonText: 'Fechar',
    ...opcoes,
  });
  if (result.value) {
    proximo(result);
  }
}

export default errorAlert;
